type MyVwConfigs = {
  launchDarklyClientKey: string;
  url: string;
};

export const getConfigurationByEnv = (baseUrl?: string) => {
  let configs: MyVwConfigs;

  const defaultConfig: MyVwConfigs = {
    launchDarklyClientKey: '',
    url: `https://qa.vwmyvwfeatureapp.svc.vwusa.io`, 
  };

  if (baseUrl) {
    configs = {
      ...defaultConfig,
      url: baseUrl,
    };
  } else {
    configs = {
      ...defaultConfig,
    };
  }

  return configs;
};
